// account-ui catalog — locale es (register: tú, informal).
import en from './en';

const es: typeof en = {
  common: {
    loading: 'Cargando…',
  },
  account: {
    brand: 'lumi HR',
    home: {
      title: 'Tu cuenta de lumi HR',
      intro:
        'Esta página es tuya, no de un espacio de trabajo. Sigue disponible aunque un espacio de trabajo al que perteneces esté bloqueado o cerrado.',
      rightsTitle: 'Lo que puedes hacer aquí',
      rights: {
        takeout: 'Descargar una copia de tus datos en cuanto esté preparada para ti.',
        erasure:
          'Pedir que se borre un espacio de trabajo y sus datos, o retirar una solicitud que hayas presentado tú.',
        invoices: 'Ver y descargar las facturas de un espacio de trabajo que administras.',
        export:
          'Exportar un espacio de trabajo del que eres propietario: todos sus datos en un archivo cifrado.',
      },
      signInHint:
        'Para todo esto tienes que iniciar sesión primero. El enlace que te enviamos por correo solo lleva a esta página: nunca inicia sesión por ti.',
      workspaceHint:
        'Todo lo demás – tu trabajo diario y tus ajustes – se queda en tu espacio de trabajo.',
    },
    signIn: {
      title: 'Iniciar sesión',
      intro:
        'Usa tu dirección de correo de lumi HR y tu contraseña. No hace falta que indiques un espacio de trabajo: te mostramos aquellos a los que perteneces.',
      email: 'Dirección de correo electrónico',
      password: 'Contraseña',
      submit: 'Iniciar sesión',
      failed: 'No hemos podido iniciar tu sesión con ese correo y esa contraseña.',
      passkey: 'Iniciar sesión con una clave de acceso',
      passkeyHint:
        '¿No tienes dirección de correo? Una cuenta creada con un número de móvil inicia sesión con su clave de acceso.',
      passkeyFailed: 'No hemos podido iniciar tu sesión con esa clave de acceso.',
      operatorSecondFactor: 'Esta es una cuenta de administrador del sistema, que necesita un segundo factor. Aquí, inicia sesión con una clave de acceso; con contraseña y código de autenticación, inicia sesión en la consola de lumi.',
    },
    session: {
      signedInAs: 'Sesión iniciada como {email}.',
      signOut: 'Cerrar sesión',
    },
    workspaces: {
      title: 'Tus espacios de trabajo',
      intro:
        'Los espacios de trabajo a los que perteneces. Un espacio bloqueado sigue en esta lista: para eso está esta página.',
      emptyTitle: 'Sin espacios de trabajo',
      emptyBody:
        'Esta cuenta no pertenece a ningún espacio de trabajo. Si esperabas ver uno aquí, pregunta a la persona que te invitó.',
      loadFailed: 'No hemos podido cargar tus espacios de trabajo.',
      ssoRequired:
        'Este espacio de trabajo exige el inicio de sesión único (SSO) de la empresa. Entra desde el propio espacio de trabajo para usar estas herramientas: aquí una contraseña no lo abre.',
      state: {
        active: 'Activo',
        suspended: 'Bloqueado',
        provisioning: 'En configuración',
        erased: 'Borrado',
        unavailable: 'No disponible',
      },
      hint: {
        active: 'Este espacio de trabajo funciona con normalidad.',
        suspended: 'Este espacio de trabajo está bloqueado. Aun así puedes ejercer aquí tus derechos.',
        provisioning: 'Este espacio de trabajo todavía se está configurando.',
        erased:
          'Este espacio de trabajo y sus datos se han borrado. Solo quedan sus facturas, porque estamos obligados a conservarlas.',
        unavailable: 'Ahora mismo no se puede acceder a este espacio de trabajo.',
      },
    },
    invoices: {
      open: 'Ver las facturas',
      hide: 'Ocultar las facturas',
      empty: 'Este espacio de trabajo no tiene facturas.',
      loadFailed: 'No hemos podido cargar las facturas de este espacio de trabajo.',
      download: 'Descargar el PDF',
      documentMissing: 'Esta factura no tiene ningún documento descargable.',
      documentUnavailable:
        'Ahora mismo no se puede obtener el documento de la factura. Sigue existiendo: inténtalo de nuevo en un momento.',
      downloadFailed: 'No hemos podido descargar esa factura.',
    },
    takeout: {
      title: 'La copia de tus datos',
      what:
        'Esta es una copia de los datos personales que este espacio de trabajo guarda sobre ti, junto con una explicación de para qué se utilizan.',
      availableUntil:
        'Puedes descargarla hasta el {date}. Después se elimina automáticamente, así que guárdala antes de esa fecha si quieres conservarla.',
      download: 'Descargar mis datos',
      none: 'Aquí no hay ninguna copia de tus datos esperándote.',
      expired:
        'La copia preparada para ti se podía descargar hasta el {date}. Desde entonces se ha eliminado, tal y como te avisamos.',
      howToAsk:
        'Puedes pedir una copia cuando quieras: ponte en contacto con el espacio de trabajo que tiene tus datos. En cuanto esté lista te enviamos un correo y la descargas en esta página.',
      loadFailed: 'No hemos podido comprobar si hay una copia de tus datos esperándote.',
      downloadUnavailable:
        'Tu copia no se puede obtener en este momento. Sigue existiendo: inténtalo de nuevo dentro de un momento.',
      downloadFailed: 'No hemos podido descargar la copia de tus datos.',
    },
    export: {
      title: 'Exportar este espacio de trabajo',
      intro:
        'Descarga todo lo que hay en este espacio de trabajo en un único archivo cifrado. También funciona mientras el espacio está bloqueado: para eso está esta página.',
      contents:
        'El archivo contiene el expediente de cada persona, cada documento subido al espacio de trabajo y sus conexiones con otros servicios. Trátalo como el propio espacio de trabajo: guárdalo en un lugar seguro y no se lo entregues a nadie que no deba verlo todo. El archivo incluye también, para Personal, Reclutamiento y Tiempo, un documento HR Open Standards (HR-JSON): el formato común para llevarte los datos a otro proveedor.',
      passphraseWarning:
        'La contraseña la eliges tú y nosotros nunca la guardamos. Sin ella el archivo ya no se puede abrir, ni por ti ni por nosotros.',
      passphraseLabel: 'Contraseña del archivo',
      passphraseHint: 'Al menos {min} caracteres.',
      confirmLabel: 'Repite la contraseña',
      submit: 'Iniciar la exportación',
      started:
        'La exportación ha empezado. Prepararla lleva un rato: vuelve a esta página y actualiza la lista.',
      errorTooShort: 'Elige una contraseña de al menos {min} caracteres.',
      errorMismatch: 'Las dos contraseñas no coinciden. Compruébalas e inténtalo de nuevo.',
      errorCannotStart:
        'La exportación no puede iniciarse ahora mismo: puede que ya haya una en marcha para este espacio de trabajo, o que el espacio de trabajo se esté cerrando.',
      errorTooMany:
        'Este espacio de trabajo ya ha iniciado hoy todas las exportaciones que puede. Inténtalo mañana.',
      errorGeneric:
        'No hemos podido iniciar la exportación. No se ha cambiado nada: inténtalo de nuevo dentro de un momento.',
      listTitle: 'Exportaciones de este espacio de trabajo',
      refresh: 'Actualizar',
      loadFailed: 'No hemos podido cargar las exportaciones de este espacio de trabajo.',
      empty: 'Todavía no se ha hecho ninguna exportación de este espacio de trabajo.',
      startedAt: 'Iniciada el {date}',
      availableUntil: 'Se puede descargar hasta el {date}',
      download: 'Descargar el archivo',
      downloadGone:
        'Este archivo ya no está disponible. Inicia una exportación nueva para obtener otro.',
      downloadUnavailable:
        'El archivo no se puede obtener en este momento. Sigue existiendo: inténtalo de nuevo dentro de un momento.',
      downloadFailed: 'No hemos podido descargar el archivo.',
      status: {
        requested: 'En cola',
        exporting: 'En preparación',
        exported: 'Lista para descargar',
        failed: 'Fallida',
        expired: 'Eliminada',
        unknown: 'Estado desconocido',
      },
    },
    erasure: {
      file: 'Solicitar el borrado de este espacio de trabajo',
      loadFailed:
        'No hemos podido comprobar si se ha solicitado el borrado de este espacio de trabajo.',
      confirmTitle: '¿Solicitar el borrado de este espacio de trabajo?',
      confirmWhatGoes:
        'Todo lo que hay en «{workspace}» se borraría de forma definitiva: cada expediente de personal, cada candidatura, cada documento, cada registro de horas y cada ajuste, para todas las personas que trabajan en él. Después no se podrá recuperar nada.',
      confirmProcess:
        'Estás presentando una solicitud, todavía no se borra nada. La revisamos y, una vez aprobada, empieza un plazo de espera. Puedes retirar la solicitud en cualquier momento hasta que el borrado comience de verdad.',
      invoicesKept: 'Las facturas se conservan, porque la ley nos obliga a guardarlas.',
      reason: 'Motivo (opcional)',
      keep: 'No, conservar este espacio de trabajo',
      confirmSubmit: 'Sí, solicitar el borrado',
      pendingReview:
        'Se ha solicitado el borrado de este espacio de trabajo. Estamos revisando la solicitud.',
      pendingUntil:
        'Se ha solicitado el borrado de este espacio de trabajo. Se borrará después del {date}.',
      paymentsPending:
        'Este espacio de trabajo está previsto para borrarse porque la cuenta no se ha pagado.',
      paymentsPendingUntil:
        'Este espacio de trabajo está previsto para borrarse porque la cuenta no se ha pagado. Se borrará después del {date}.',
      paymentsSettle:
        'Pagar la factura pendiente detiene este borrado. También puedes solicitar el borrado tú mismo: entonces seguirá adelante pase lo que pase con el pago.',
      paymentsCannotWithdraw:
        'Este borrado se programó porque la cuenta no se ha pagado, así que aquí no se puede retirar. Paga la factura pendiente para detenerlo.',
      confirmTakeover:
        'Este espacio de trabajo ya está previsto para borrarse porque la cuenta no se ha pagado. Tu solicitud asume ese borrado: pagar la factura ya no lo detendrá.',
      withdraw: 'Retirar la solicitud de borrado',
      withdrawTitle: '¿Retirar la solicitud de borrado?',
      withdrawBody:
        'Este espacio de trabajo y todos sus datos se conservan. Puedes volver a solicitar el borrado cuando quieras.',
      confirmType: 'Escribe el nombre del espacio de trabajo ({name}) para confirmar',
      confirmMismatch:
        'El nombre que has escrito no coincide con este espacio de trabajo. Compruébalo e inténtalo de nuevo.',
      tooLate: 'El borrado ya ha empezado y no se puede retirar.',
      conflict: 'Este espacio de trabajo ya se está borrando, así que no ha cambiado nada.',
      nothingOpen: 'No hay ninguna solicitud de borrado que retirar para este espacio de trabajo.',
      filed: 'Hemos recibido tu solicitud de borrado. La revisaremos.',
      withdrawn: 'Se ha retirado la solicitud de borrado. Este espacio de trabajo se mantiene.',
    },
    closure: {
      title: 'Cerrar tu cuenta de lumi',
      intro:
        'Aquí se trata de tu propia cuenta de lumi —tu acceso— y no de uno de los espacios de trabajo de arriba.',
      open: 'Cerrar mi cuenta',
      confirmTitle: '¿Cerrar tu cuenta de lumi?',
      whatGoes:
        'Tu acceso desaparece: esta dirección de correo y esta contraseña dejan de funcionar, se desconecta el inicio de sesión único de empresa que hayas vinculado y sales de todos los espacios de trabajo a los que perteneces. Lo que hiciste tú en lumi también desaparece: borramos tus conversaciones con el asistente, las notificaciones que te enviamos y tus ajustes para ellas, y quitamos tu nombre y lo que escribiste de las consultas de soporte y los mensajes que nos enviaste.',
      whatStays:
        'Tus datos en cada empresa se quedan con esa empresa. lumi opera los sistemas, pero cada compañía sigue siendo responsable de sus datos de personal y de candidatura, y cerrar tu cuenta aquí no los borra. Si un espacio de trabajo está afectado por un proceso judicial o una investigación oficial, tenemos que conservar lo que está relacionado con él: tus consultas, mensajes y conversaciones de ese espacio se quedan hasta que eso termine.',
      howToErase:
        'Si quieres que se borren los datos que tiene una empresa, pídeselo directamente a esa empresa. Es ella quien responde a esa petición, y una parte está obligada por ley a conservarla algún tiempo más.',
      noUndo:
        'El cierre no se puede deshacer y no dejamos nada en espera por ti. Puedes registrarte de nuevo cuando quieras con la misma dirección de correo: será una cuenta nueva y vacía.',
      confirmType: 'Escribe tu dirección de correo ({email}) para confirmar',
      confirmMismatch:
        'Esa no es la dirección de correo de esta cuenta. Compruébala e inténtalo de nuevo.',
      keep: 'No, conservar mi cuenta',
      confirmSubmit: 'Sí, cerrar mi cuenta',
      doneTitle: 'Tu cuenta está cerrada',
      doneBody:
        'Se ha cerrado tu sesión, y con esta dirección de correo y esta contraseña ya no se puede entrar en ninguna parte de lumi. Tus conversaciones con el asistente y las notificaciones que te enviamos están borradas, y las consultas de soporte y los mensajes que nos enviaste ya no llevan tu nombre ni lo que escribiste.',
      doneStays:
        'Tus datos en cada empresa se quedan con esa empresa y siguen bajo su gestión. Para que los borren, pídeselo directamente a cada empresa. Y si un espacio de trabajo está afectado por un proceso judicial o una investigación oficial, lo que está relacionado con él se queda con nosotros hasta que eso termine.',
      doneMailed: 'Te hemos enviado una confirmación por correo electrónico.',
      doneNotMailed:
        'No hemos podido enviarte el correo de confirmación. Tu cuenta está cerrada igualmente.',
      blockedTitle: 'Estos espacios de trabajo todavía necesitan un propietario',
      blockedBody:
        'Eres la única persona propietaria de los espacios de trabajo de abajo, así que todavía no podemos cerrar tu cuenta. Un espacio sin propietario solo podemos reabrirlo nosotros, y todas las personas que trabajan en él se quedarían sin acceso a sus propios datos.',
      blockedTransfer:
        'Traspasa «{name}»: abre ese espacio de trabajo y transfiere allí la propiedad a otro miembro.',
      blockedErasure:
        'O solicita el borrado de «{name}» en la lista de tus espacios de trabajo de arriba.',
      blockedReturn:
        'Este intento no queda guardado. Cuando ningún espacio de trabajo te necesite como propietario, vuelve a esta página y cierra entonces tu cuenta.',
      unavailable:
        'El cierre de cuentas no funciona en este momento. No se ha cambiado nada: inténtalo de nuevo en un momento.',
      alreadyClosed: 'Esta cuenta ya está cerrada.',
      failed: 'No ha funcionado. Tu cuenta no se ha cerrado: inténtalo de nuevo en un momento.',
      confirmTypePhone: 'Escribe tu número de móvil completo ({phone}) para confirmar',
      confirmMismatchPhone:
        'Ese no es el número de móvil de esta cuenta. Compruébalo e inténtalo de nuevo.',
      whatGoesPhone:
        'Tu acceso desaparece: tus claves de acceso y este número de móvil dejan de funcionar, se desconecta el inicio de sesión único de empresa que hayas vinculado y sales de todos los espacios de trabajo a los que perteneces. Lo que hiciste tú en lumi también desaparece: borramos tus conversaciones con el asistente, las notificaciones que te enviamos y tus ajustes para ellas, y quitamos tu nombre y lo que escribiste de las consultas de soporte y los mensajes que nos enviaste.',
      noUndoPhone:
        'El cierre no se puede deshacer y no dejamos nada en espera por ti. Un espacio de trabajo puede volver a invitarte con el mismo número: será una cuenta nueva y vacía.',
      doneBodyPhone:
        'Se ha cerrado tu sesión, y con tus claves de acceso y este número de móvil ya no se puede entrar en ninguna parte de lumi. Tus conversaciones con el asistente y las notificaciones que te enviamos están borradas, y las consultas de soporte y los mensajes que nos enviaste ya no llevan tu nombre ni lo que escribiste.',
      doneScreenOnly: 'Esta pantalla es tu confirmación: no enviamos ninguna por SMS.',
    },
  },
};

export default es;
